import { useMemo } from "react";
import { extractData } from "../../utils/analytics/extractData";

export const useAnalyticsParams = (dateRange, defaultChannel) => {
  const params = useMemo(() => {
    if (!defaultChannel || !dateRange?.[0]) return null;
    return extractData(dateRange, defaultChannel);
  }, [dateRange, defaultChannel]);

  return {
    params,
    skip: !params,
  };
};

export default useAnalyticsParams;
